module.exports = __webpack_public_path__ + "static/media/help.d5037fcb.svg";